import React from 'react';
import { Card } from 'antd';
import './StatsKPIGroup.css';

export interface KPIItem {
  title: string;
  value: number;
  suffix?: string;
  precision?: number;
  color?: string;
  prefix?: string;
  remark?: string;
  remarkColor?: string;
}

interface Props {
  items: KPIItem[];
}

const COLORS = ['#52c41a', '#1890ff', '#fa8c16', '#f5222d', '#722ed1', '#13c2c2'];

const formatKPIValue = (value: number, precision?: number) => {
  if (!Number.isFinite(value)) return String(value ?? '');
  if (precision !== undefined) {
    return value.toLocaleString(undefined, {
      minimumFractionDigits: precision,
      maximumFractionDigits: precision,
    });
  }
  return value.toLocaleString();
};

const StatsKPIGroup: React.FC<Props> = ({ items }) => {
  return (
    <div className="kpi-group">
      <div className="kpi-grid">
        {items.map((item, idx) => {
          const color = item.color || COLORS[idx % COLORS.length];
          const valueText = formatKPIValue(item.value, item.precision);
          return (
            <Card key={`${item.title}-${idx}`} className="kpi-card" bordered={false} style={{ borderLeft: `6px solid ${color}` }}>
              <div className="kpi-card-inner">
                <div className="kpi-card-content">
                  <div className="kpi-card-title">{item.title}</div>
                  <div className="kpi-card-value">
                    {item.prefix && <span className="kpi-card-prefix">{item.prefix}</span>}
                    {valueText}
                    {item.suffix && <span className="kpi-card-suffix">{item.suffix}</span>}
                  </div>
                  {item.remark && (
                    <div className="kpi-card-remark" style={{ color: item.remarkColor || color }}>
                      {item.remark}
                    </div>
                  )}
                </div>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default StatsKPIGroup;
